import {session} from 'lib/StorageUtil';

/**
 * Masquerade lives in an in-memory Flux store, so a page refresh drops it. We
 * mirror the minimal rehydratable state to `sessionStorage` so the store can
 * restore it on reload within the same browser session. Only ids are kept — the
 * panel re-fetches the teacher/school by id after refresh.
 *
 * `adminId` binds the persisted state to the admin who started masquerading so
 * a stale entry can't be honored for a different account sharing the tab (see
 * `MasqueradeStore.isMasquerading`). Nothing sensitive is stored: these are
 * opaque UUIDs + a route path, never tokens (the auth JWT stays in its
 * httpOnly cookie).
 */
const MASQUERADE_STORAGE_KEY = 'albert:masquerade';

export interface PersistedMasqueradeState {
  adminId: string;
  userId: string;
  schoolId: string;
  origin: string | null;
}

export function readMasqueradeState(): PersistedMasqueradeState | null {
  const state = session.get(MASQUERADE_STORAGE_KEY, null) as PersistedMasqueradeState | null;
  if (!state || !state.adminId || !state.userId || !state.schoolId) {
    return null;
  }
  return state;
}

export function writeMasqueradeState(state: PersistedMasqueradeState): void {
  session.set(MASQUERADE_STORAGE_KEY, state);
}

export function clearMasqueradeState(): void {
  session.remove(MASQUERADE_STORAGE_KEY);
}
